module.exports = __webpack_public_path__ + "img/restart.b4197288.svg";